export const MODULE_NAME = 'app'
export const START_LOADING = 'START_LOADING'
export const STOP_LOADING = 'STOP_LOADING'
